import { z } from 'zod';
import { BaseErrorSchema } from 'libs/end-to-end/src/types/errors/base-error-schema';

export const ResponseParseJsonError = BaseErrorSchema.extend({
  errorType: z.literal('ResponseParseJsonError'),
  errorReason: z.string(),
});

export type ResponseParseJsonError = z.infer<typeof ResponseParseJsonError>;
